export default [
    {
        path: '/page/index.html',
        component: (resolve) => require(['@/view/page/index.vue'],resolve),
    },
    {
        path: '/page/diy.html',
        component: (resolve) => require(['@/view/page/diy.vue'], resolve),
    },
]
